import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { goNextScreen } from '../../store/screenSlice'
import { Button } from '../Button/Button'

import styles from './NextButton.module.scss'
import arrowRight from './arrow-right.png'


function NextButtonBody({ onClick, goNextScreen }) {
    const onClickHandler = useCallback((ev) => {
        if (onClick) {
            onClick()
        }
        goNextScreen()
    }, [onClick, goNextScreen])

    return (
        <Button
            isNeedRegisterResource={false}
            src={arrowRight}
            onClick={onClickHandler}
            className={styles.nextButton}
        />
    )
}

NextButtonBody.propTypes = {
    onClick: PropTypes.func,
    goNextScreen: PropTypes.func.isRequired,
}

const NextButton = connect(
    null,
    {
        goNextScreen,
    },
)(NextButtonBody)

NextButton.propTypes = {
    onClick: PropTypes.func,
}

export { NextButton }
